<template>
    <div>
        <h1>{{ t('Volunteers') }}</h1>
        <BRow>
            <BCol cols="12" md="4" lg="4">
                <p>{{ t('If you would like to take part in a large-scale cultural project, please join the team of volunteers Cosmoscow')}}.</p>
                <p>{{ t('We will provide work in an international project, communicating with artists, curators and other art professionals') }}.</p>
                <p>{{ t('Participation in various events can become part of your life') }}.</p>
            </BCol>
            <BCol cols="12" md="8" lg="8">
                <RoundedPanel>
                    <VolunteerForm />
                </RoundedPanel>
            </BCol>
        </BRow>
    </div>
</template>

<script setup lang="ts">
import VolunteerForm from '@/components/site/about/VolunteerForm.vue'
const { t } = useI18n()

definePageMeta({
    auth: 'guest',
    layout: 'about-layout',
})

useHead({
    title: t('Volunteers'),
})
</script>

<i18n lang="json">
    {
        "ru": {
            "Volunteers": "Волонтёрам",
            "If you would like to take part in a large-scale cultural project, please join the team of volunteers Cosmoscow": "Если вы хотите принять участие в масштабном культурном проекте, присоединяйтесь к команде волонтеров Cosmoscow",
            "We will provide work in an international project, communicating with artists, curators and other art professionals": "Работа в международном проекте, живое общение с художниками, кураторами и другими профессионалами арт-сферы",
            "Participation in various events can become part of your life": "Участие в разнообразных мероприятиях ярмарки — все это может стать частью вашей жизни"
        }
    }
</i18n>